import { render, staticRenderFns } from "./copyrightsComponent.vue?vue&type=template&id=a9b5f03a&scoped=true&"
import script from "./copyrightsComponent.vue?vue&type=script&lang=js&"
export * from "./copyrightsComponent.vue?vue&type=script&lang=js&"
import style0 from "./copyrightsComponent.vue?vue&type=style&index=0&id=a9b5f03a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5f03a",
  null
  
)

export default component.exports